import React from "react";
import { Link } from "react-router-dom";
import "./Home.css"; // スタイル用のCSSファイル

function Home() {
  return (
    <div className="home-container">
      <main className="home-main">
        <div className="feature-cards">
          <Link
            to="https://hakobune.8thwall.app/tomagoudon-ar/"
            className="feature-card"
          >
            <img src="/megane_btn.png" alt="メガネAR 3D" />
            <span className="badge-3d">3D</span>
            <span className="badge-users">3人まで</span>
          </Link>
          <Link to="/megane" className="feature-card">
            <img src="/megane_btn.png" alt="メガネAR" />
            <span className="badge-users">4人以上</span>
          </Link>
          <Link to="/photoframe" className="feature-card">
            <img src="/photoframe_btn.png" alt="フォトフレーム" />
          </Link>
        </div>
      </main>
    </div>
  );
}

export default Home;
